import DiseasePreview from './DiseasePreview';

export default DiseasePreview;
